export { default } from "./EmbedVideoSkeleton";
